var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"normal-radiobox",class:{
    disabled: _vm.disabled
}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isChecked),expression:"isChecked"}],staticClass:"normal-radio",attrs:{"type":"radio","name":_vm.label,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm._q(_vm.isChecked,_vm.value)},on:{"change":function($event){_vm.isChecked=_vm.value}}}),_c('i',{staticClass:"normal-check-icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }